"use strict";
import {on, find, findIn, closest, hasClass, removeAttribute, setAttribute} from "@elements/dom-utils";
import axios from "axios";
import {unCompleteTab, switchTab, loadPanelContents} from "../tabManager";
import {hasEntries, push, pop} from "../changeHistory";
import {getDimensionValues, setDimensionValues, updateOutline, completeOutline} from "../outline/outlineUI";
import TerracePlanner from "../index";

let backendUrl = window.location.protocol + '//' + window.location.hostname + '/r/terraceplanner/plankPattern/resize?operation=';
let undoButton;

export function init() {
    undoButton = findIn('.js-planner__pattern-resize-undo', TerracePlanner.element);
    let enlargeButton = findIn('.js-planner__pattern-enlarge', TerracePlanner.element);
    let shrinkButton = findIn('.js-planner__pattern-shrink', TerracePlanner.element);

    if (enlargeButton) {
        on('click', (evt) => resizeListener(evt, enlargeButton), enlargeButton);
    }

    if (shrinkButton) {
        on('click', (evt) => resizeListener(evt, shrinkButton), shrinkButton);
    }

    if(undoButton && hasEntries('outline')) {
        removeAttribute('hidden', undoButton);
        on('click', (evt) => undoResizeListener(), undoButton);
    }
}

/**
 * listener to send an xhr to the backend to resize the current floor plan
 *
 * @param evt
 * @param button
 */
function resizeListener(evt, button) {
    let operation = button.getAttribute('data-operation');
    push('outline', getDimensionValues());

    if (0 === Number(operation)) {
        return;
    }

    axios({
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        url: backendUrl + operation,
        responseType: 'json'
    }).then(({data: {success, data}}) => {
        loadPanelContents('outline'); //this will update dimension values in the outline tab
        unCompleteTab('plankPattern');
        switchTab('plankPattern');
    });

    // $.ajax(backendUrl + operation, {
    //     success: function () {
    //         terracePlannerTabManager.loadPanel('outline'); //this will update dimension values in the outline tab
    //         terracePlannerTabManager.unCompleteTab('plankPattern');
    //         terracePlannerTabManager.switchTab('plankPattern');
    //     }
    // });
}

/**
 * listener to undo resizing
 *
 * @param event
 */
function undoResizeListener() {
    let dimensions = pop('outline') || {};
    setDimensionValues(dimensions);
    updateOutline();
    completeOutline();
}